<ph-dialog [open]="open" size="md" heading="Let's configure and verify your Stripe account to process online payments." (ph-close)="closed.emit({ startVerification: false })">
    <ph-stack class="list-styled">
        <div>To enable secure financial operations and comply with regulatory requirements, we need to verify your identity. This one-time verification is required to process online payments, issue spend cards, or use your PayHOA Financial Account. It only takes a couple of minutes!</div>

        <ph-stack gap="tight">
            <div><strong>What we'll need from you:</strong></div>
            <ul>
                <li>Business details, including your HOA's legal name, address, and EIN (Employer Identification Number).</li>
                <li>Contact information for the primary account holder or authorized representative.</li>
                <li>Verification documents, such as a government-issued ID or business registration, to comply with regulatory requirements.</li>
                <li>Your consent to the required legal agreements for account and card services.</li>
            </ul>
        </ph-stack>

        <ph-stack gap="tight">
            <div>By clicking "Start verification," you'll be guided through a secure process to provide this information, activate your PayHOA Financial Account, and review the following agreements:</div>
            <ul>
                <li><ph-link-button variant="primary" [attr.href]="stripeUrls.SERVICES_AGREEMENT" target="_blank" rel="noopener">Stripe Services Agreement</ph-link-button></li>
                <li><ph-link-button variant="primary" [attr.href]="stripeUrls.CONNECTED_ACCOUNT_AGREEMENT" target="_blank" rel="noopener">Stripe Connected Account Agreement</ph-link-button></li>
                <li><ph-link-button variant="primary" [attr.href]="stripeUrls.ISSUING_BANK_TERMS" target="_blank" rel="noopener">Issuing Bank Terms (Celtic Bank)</ph-link-button></li>
            </ul>
        </ph-stack>

        <ph-hint><span [innerHTML]="disclosureText"></span></ph-hint>
    </ph-stack>

    <ph-actions slot="footer">
        <ph-button (click)="closed.emit({ startVerification: true })">Start verification</ph-button>
    </ph-actions>
</ph-dialog>
